/*!
 * Built by Revolist
 */
import { E as Edit, d as defineCustomElement$1 } from './revogr-edit2.js';

const RevogrEdit = Edit;
const defineCustomElement = defineCustomElement$1;

export { RevogrEdit, defineCustomElement };
